import React, { useState } from "react";

const ReferralForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    mobile: "",
    company: "",
    category: "",
    email: "",
    areaLocation: "",
    city: "",
    district: "",
  });

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setMessage("");

    if (
      !formData.name ||
      !formData.mobile ||
      !formData.company ||
      !formData.category ||
      !formData.city
    ) {
      setMessage(
        "Please fill Name, Mobile, Company, Category and City."
      );
      return;
    }

    try {
      setLoading(true);

      const token = localStorage.getItem("token");

      const response = await fetch(
        "http://localhost:5000/referrals",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(formData),
        }
      );

      const result = await response.json();

      if (!response.ok) {
        throw new Error(
          result.message || "Failed to submit referral"
        );
      }

      setMessage("Referral submitted successfully!");

      setFormData({
        name: "",
        mobile: "",
        company: "",
        category: "",
        email: "",
        areaLocation: "",
        city: "",
        district: "",
      });
    } catch (error) {
      console.error("Referral Error:", error);
      setMessage(
        error.message || "Something went wrong."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        padding: "30px",
        background: "#f7f7f7",
        minHeight: "100vh",
      }}
    >
      <div
        style={{
          maxWidth: "900px",
          margin: "0 auto",
          background: "#ffffff",
          borderRadius: "12px",
          padding: "30px",
          boxShadow: "0 2px 10px rgba(0,0,0,0.08)",
        }}
      >
        <h2
          style={{
            marginBottom: "5px",
            color: "#f58220",
            fontSize: "28px",
          }}
        >
          Refer Form
        </h2>

        <p
          style={{
            marginTop: "0",
            marginBottom: "25px",
            color: "#555",
          }}
        >
          Refer & Earn 500RS
        </p>

        {message && (
          <div
            style={{
              marginBottom: "20px",
              padding: "12px",
              borderRadius: "6px",
              background: "#fff3e8",
              color: "#d96b00",
            }}
          >
            {message}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: "20px",
            }}
          >
            <div>
              <label>Name / Mobile</label>

              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="Enter name"
                style={inputStyle}
              />

              <input
                type="text"
                name="mobile"
                value={formData.mobile}
                onChange={handleChange}
                placeholder="Enter mobile number"
                style={{
                  ...inputStyle,
                  marginTop: "10px",
                }}
              />
            </div>

            <div>
              <label>Company / Category</label>

              <input
                type="text"
                name="company"
                value={formData.company}
                onChange={handleChange}
                placeholder="Enter company"
                style={inputStyle}
              />

              <input
                type="text"
                name="category"
                value={formData.category}
                onChange={handleChange}
                placeholder="Enter category"
                style={{
                  ...inputStyle,
                  marginTop: "10px",
                }}
              />
            </div>

            <div>
              <label>Email</label>

              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Enter email"
                style={inputStyle}
              />
            </div>

            <div>
              <label>Area / Location</label>

              <input
                type="text"
                name="areaLocation"
                value={formData.areaLocation}
                onChange={handleChange}
                placeholder="Enter area / location"
                style={inputStyle}
              />
            </div>

            <div>
              <label>City</label>

              <input
                type="text"
                name="city"
                value={formData.city}
                onChange={handleChange}
                placeholder="Enter city"
                style={inputStyle}
              />
            </div>

            <div>
              <label>District</label>

              <input
                type="text"
                name="district"
                value={formData.district}
                onChange={handleChange}
                placeholder="Enter district"
                style={inputStyle}
              />
            </div>
          </div>

          <button
            type="submit"
            disabled={loading}
            style={{
              marginTop: "30px",
              background: "#f58220",
              color: "#ffffff",
              border: "none",
              padding: "13px 30px",
              borderRadius: "6px",
              cursor: loading ? "not-allowed" : "pointer",
              fontSize: "16px",
              fontWeight: "600",
            }}
          >
            {loading ? "Submitting..." : "Submit Referral"}
          </button>
        </form>
      </div>
    </div>
  );
};

const inputStyle = {
  width: "100%",
  boxSizing: "border-box",
  padding: "12px",
  marginTop: "7px",
  border: "1px solid #ddd",
  borderRadius: "6px",
  outline: "none",
  fontSize: "14px",
};

export default ReferralForm;